import React from "react";
import { Link } from "react-router-dom";
import {QuestionCircleFilled,PlusCircleFilled,PauseCircleFilled,MinusCircleFilled,PlusSquareFilled,MinusSquareFilled,InfoCircleFilled,ExclamationCircleFilled,CloseCircleFilled,CloseSquareFilled,CheckCircleFilled,CheckSquareFilled,ClockCircleFilled,WarningFilled,StopFilled,EditFilled,CopyFilled,DeleteFilled,SnippetsFilled,DiffFilled,HighlightFilled,PieChartFilled,BoxPlotFilled,FundFilled,SlidersFilled,AndroidFilled,AppleFilled,WindowsFilled,ChromeFilled,GithubFilled,AliwangwangFilled,WeiboSquareFilled,WeiboCircleFilled,TaobaoCircleFilled,Html5Filled,WechatFilled,YoutubeFilled,AlipayCircleFilled,SkypeFilled,GitlabFilled,LinkedinFilled,FacebookFilled,CodeSandboxCircleFilled,CodepenCircleFilled,SlackSquareFilled,BehanceSquareFilled,DribbbleSquareFilled,InstagramFilled,YuqueFilled,YahooFilled,AccountBookFilled,AlertFilled,AlipaySquareFilled,AmazonCircleFilled,AmazonSquareFilled,ApiFilled,AppstoreFilled,AudioFilled,BankFilled,BehanceCircleFilled,BellFilled,BookFilled,BugFilled,BuildFilled,BulbFilled,CalculatorFilled,CalendarFilled,CameraFilled,CarFilled,CarryOutFilled,CiCircleFilled,CloudFilled,CodeFilled,CodeSandboxSquareFilled,CodepenSquareFilled,CompassFilled,ContactsFilled,ContainerFilled,ControlFilled,CreditCardFilled,CrownFilled,CustomerServiceFilled,DashboardFilled,DatabaseFilled,DingtalkCircleFilled,DingtalkSquareFilled,DislikeFilled,DollarCircleFilled,DribbbleCircleFilled,DropboxCircleFilled,DropboxSquareFilled,EnvironmentFilled,EuroCircleFilled,ExperimentFilled,EyeFilled,EyeInvisibleFilled,FileAddFilled,FileExcelFilled,FileExclamationFilled,FileFilled,FileImageFilled,FileMarkdownFilled,FilePdfFilled,FilePptFilled,FileTextFilled,FileUnknownFilled,FileWordFilled,FileZipFilled,FilterFilled,FireFilled,FlagFilled,FolderAddFilled,FolderFilled,FolderOpenFilled,FormatPainterFilled,FrownFilled,FunnelPlotFilled,GiftFilled,GoldFilled,GoldenFilled,GoogleCircleFilled,GooglePlusCircleFilled,GooglePlusSquareFilled,GoogleSquareFilled,HddFilled,HeartFilled,HomeFilled,HourglassFilled,IdcardFilled,IeCircleFilled,IeSquareFilled,InsuranceFilled,InteractionFilled,LayoutFilled,LikeFilled,LockFilled,MacCommandFilled,MailFilled,MedicineBoxFilled,MediumCircleFilled,MediumSquareFilled,MehFilled,MessageFilled,MobileFilled,MoneyCollectFilled,NotificationFilled,PayCircleFilled,PhoneFilled,PictureFilled,PlaySquareFilled,PoundCircleFilled,PrinterFilled,ProfileFilled,ProjectFilled,PropertySafetyFilled,PushpinFilled,QqCircleFilled,QqSquareFilled,ReadFilled,ReconciliationFilled,RedEnvelopeFilled,RedditCircleFilled,RedditSquareFilled,RestFilled,RobotFilled,RocketFilled,SafetyCertificateFilled,SaveFilled,ScheduleFilled,SecurityScanFilled,SettingFilled,ShopFilled,ShoppingFilled,SignalFilled,SketchCircleFilled,SketchSquareFilled,SkinFilled,SlackCircleFilled,SmileFilled,SoundFilled,StarFilled,SwitcherFilled,TabletFilled,TagFilled,TagsFilled,TaobaoSquareFilled,ThunderboltFilled,ToolFilled,TrademarkCircleFilled,TrophyFilled,TwitterCircleFilled,TwitterSquareFilled,UnlockFilled,UsbFilled,VideoCameraFilled,WalletFilled,ZhihuCircleFilled,ZhihuSquareFilled} from "@ant-design/icons";
const MaterialIcons = () => {
  return (
    <div className="page-wrapper cardhead">
      <div className="content container-fluid">
        {/* Page Header */}
        <div className="page-header">
          <div className="row">
            <div className="col-sm-12">
              <h3 className="page-title">Material Icon</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dream-pos/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Material Icon</li>
              </ul>
            </div>
          </div>
        </div>
        {/* /Page Header */}
        <div className="row">
          {/* Chart */}
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <div className="card-title">Material Icons</div>
              </div>
              <div className="card-body">
                <div className="icons-items">
                  <ul className="icons-list">
                    <li>
                      <QuestionCircleFilled />
                    </li>
                    <li>
                      <PlusCircleFilled />
                    </li>
                    <li>
                      <PauseCircleFilled />
                    </li>
                    <li>
                      <MinusCircleFilled />
                    </li>
                    <li>
                      <PlusSquareFilled />
                    </li>
                    <li>
                      <MinusSquareFilled />
                    </li>
                    <li>
                      <InfoCircleFilled />
                    </li>
                    <li>
                      <ExclamationCircleFilled />
                    </li>
                    <li>
                      <CloseCircleFilled />
                    </li>
                    <li>
                      <CloseSquareFilled />
                    </li>
                    <li>
                      <CheckCircleFilled />
                    </li>
                    <li>
                      <CheckSquareFilled />
                    </li>
                    <li>
                      <ClockCircleFilled />
                    </li>
                    <li>
                      <WarningFilled />
                    </li>
                    <li>
                      <StopFilled />
                    </li>
                    <li>
                      <EditFilled />
                    </li>
                    <li>
                      <CopyFilled />
                    </li>
                    <li>
                      <DeleteFilled />
                    </li>
                    <li>
                      <SnippetsFilled />
                    </li>
                    <li>
                      <DiffFilled />
                    </li>
                    <li>
                      <HighlightFilled />
                    </li>
                    <li>
                      <PieChartFilled />
                    </li>
                    <li>
                      <BoxPlotFilled />
                    </li>
                    <li>
                      <FundFilled />
                    </li>
                    <li>
                      <SlidersFilled />
                    </li>
                    <li>
                      <AndroidFilled />
                    </li>
                    <li>
                      <AppleFilled />
                    </li>
                    <li>
                      <WindowsFilled />
                    </li>
                    <li>
                      <ChromeFilled />
                    </li>
                    <li>
                      <GithubFilled />
                    </li>
                    <li>
                      <AliwangwangFilled />
                    </li>
                    <li>
                      <WeiboSquareFilled />
                    </li>
                    <li>
                      <WeiboCircleFilled />
                    </li>
                    <li>
                      <TaobaoCircleFilled />
                    </li>
                    <li>
                      <Html5Filled />
                    </li>
                    <li>
                      <WechatFilled />
                    </li>
                    <li>
                      <YoutubeFilled />
                    </li>
                    <li>
                      <AlipayCircleFilled />
                    </li>
                    <li>
                      <SkypeFilled />
                    </li>
                    <li>
                      <GitlabFilled />
                    </li>
                    <li>
                      <LinkedinFilled />
                    </li>
                    <li>
                      <FacebookFilled />
                    </li>
                    <li>
                      <CodeSandboxCircleFilled />
                    </li>
                    <li>
                      <CodepenCircleFilled />
                    </li>
                    <li>
                      <SlackSquareFilled />
                    </li>
                    <li>
                      <BehanceSquareFilled />
                    </li>
                    <li>
                      <DribbbleSquareFilled />
                    </li>
                    <li>
                      <InstagramFilled />
                    </li>
                    <li>
                      <YuqueFilled />
                    </li>
                    <li>
                      <YahooFilled />
                    </li>
                    <li>
                      <AccountBookFilled />
                    </li>
                    <li>
                      <AlertFilled />
                    </li>
                    <li>
                      <AlipaySquareFilled />
                    </li>
                    <li>
                      <AmazonCircleFilled />
                    </li>
                    <li>
                      <AmazonSquareFilled />
                    </li>
                    <li>
                      <ApiFilled />
                    </li>
                    <li>
                      <AppstoreFilled />
                    </li>
                    <li>
                      <AudioFilled />
                    </li>
                    <li>
                      <BankFilled />
                    </li>
                    <li>
                      <BehanceCircleFilled />
                    </li>
                    <li>
                      <BellFilled />
                    </li>
                    <li>
                      <BookFilled />
                    </li>
                    <li>
                      <BugFilled />
                    </li>
                    <li>
                      <BuildFilled />
                    </li>
                    <li>
                      <BulbFilled />
                    </li>
                    <li>
                      <CalculatorFilled />
                    </li>
                    <li>
                      <CalendarFilled />
                    </li>
                    <li>
                      <CameraFilled />
                    </li>
                    <li>
                      <CarFilled />
                    </li>
                    <li>
                      <CarryOutFilled />
                    </li>
                    <li>
                      <CiCircleFilled />
                    </li>
                    <li>
                      <CloudFilled />
                    </li>
                    <li>
                      <CodeFilled />
                    </li>
                    <li>
                      <CodeSandboxSquareFilled />
                    </li>
                    <li>
                      <CodepenSquareFilled />
                    </li>
                    <li>
                      <CompassFilled />
                    </li>
                    <li>
                      <ContactsFilled />
                    </li>
                    <li>
                      <ContainerFilled />
                    </li>
                    <li>
                      <ControlFilled />
                    </li>
                    <li>
                      <CreditCardFilled />
                    </li>
                    <li>
                      <CrownFilled />
                    </li>
                    <li>
                      <CustomerServiceFilled />
                    </li>
                    <li>
                      <DashboardFilled />
                    </li>
                    <li>
                      <DatabaseFilled />
                    </li>
                    <li>
                      <DingtalkCircleFilled />
                    </li>
                    <li>
                      <DingtalkSquareFilled />
                    </li>
                    <li>
                      <DislikeFilled />
                    </li>
                    <li>
                      <DollarCircleFilled />
                    </li>
                    <li>
                      <DribbbleCircleFilled />
                    </li>
                    <li>
                      <DropboxCircleFilled />
                    </li>
                    <li>
                      <DropboxSquareFilled />
                    </li>
                    <li>
                      <EnvironmentFilled />
                    </li>
                    <li>
                      <EuroCircleFilled />
                    </li>
                    <li>
                      <ExperimentFilled />
                    </li>
                    <li>
                      <EyeFilled />
                    </li>
                    <li>
                      <EyeInvisibleFilled />
                    </li>
                    <li>
                      <FileAddFilled />
                    </li>
                    <li>
                      <FileExcelFilled />
                    </li>
                    <li>
                      <FileExclamationFilled />
                    </li>
                    <li>
                      <FileFilled />
                    </li>
                    <li>
                      <FileImageFilled />
                    </li>
                    <li>
                      <FileMarkdownFilled />
                    </li>
                    <li>
                      <FilePdfFilled />
                    </li>
                    <li>
                      <FilePptFilled />
                    </li>
                    <li>
                      <FileTextFilled />
                    </li>
                    <li>
                      <FileUnknownFilled />
                    </li>
                    <li>
                      <FileWordFilled />
                    </li>
                    <li>
                      <FileZipFilled />
                    </li>
                    <li>
                      <FilterFilled />
                    </li>
                    <li>
                      <FireFilled />
                    </li>
                    <li>
                      <FlagFilled />
                    </li>
                    <li>
                      <FolderAddFilled />
                    </li>
                    <li>
                      <FolderFilled />
                    </li>
                    <li>
                      <FolderOpenFilled />
                    </li>
                    <li>
                      <FormatPainterFilled />
                    </li>
                    <li>
                      <FrownFilled />
                    </li>
                    <li>
                      <FunnelPlotFilled />
                    </li>
                    <li>
                      <GiftFilled />
                    </li>
                    <li>
                      <GoldFilled />
                    </li>
                    <li>
                      <GoldenFilled />
                    </li>
                    <li>
                      <GoogleCircleFilled />
                    </li>
                    <li>
                      <GooglePlusCircleFilled />
                    </li>
                    <li>
                      <GooglePlusSquareFilled />
                    </li>
                    <li>
                      <GoogleSquareFilled />
                    </li>
                    <li>
                      <HddFilled />
                    </li>
                    <li>
                      <HeartFilled />
                    </li>
                    <li>
                      <HomeFilled />
                    </li>
                    <li>
                      <HourglassFilled />
                    </li>
                    <li>
                      <IdcardFilled />
                    </li>
                    <li>
                      <IeCircleFilled />
                    </li>
                    <li>
                      <IeSquareFilled />
                    </li>
                    <li>
                      <InsuranceFilled />
                    </li>
                    <li>
                      <InteractionFilled />
                    </li>
                    <li>
                      <LayoutFilled />
                    </li>
                    <li>
                      <LikeFilled />
                    </li>
                    <li>
                      <LockFilled />
                    </li>
                    <li>
                      <MacCommandFilled />
                    </li>
                    <li>
                      <MailFilled />
                    </li>
                    <li>
                      <MedicineBoxFilled />
                    </li>
                    <li>
                      <MediumCircleFilled />
                    </li>
                    <li>
                      <MediumSquareFilled />
                    </li>
                    <li>
                      <MehFilled />
                    </li>
                    <li>
                      <MessageFilled />
                    </li>
                    <li>
                      <MobileFilled />
                    </li>
                    <li>
                      <MoneyCollectFilled />
                    </li>
                    <li>
                      <NotificationFilled />
                    </li>
                    <li>
                      <PayCircleFilled />
                    </li>
                    <li>
                      <PhoneFilled />
                    </li>
                    <li>
                      <PictureFilled />
                    </li>
                    <li>
                      <PlaySquareFilled />
                    </li>
                    <li>
                      <PoundCircleFilled />
                    </li>
                    <li>
                      <PrinterFilled />
                    </li>
                    <li>
                      <ProfileFilled />
                    </li>
                    <li>
                      <ProjectFilled />
                    </li>
                    <li>
                      <PropertySafetyFilled />
                    </li>
                    <li>
                      <PushpinFilled />
                    </li>
                    <li>
                      <QqCircleFilled />
                    </li>
                    <li>
                      <QqSquareFilled />
                    </li>
                    <li>
                      <ReadFilled />
                    </li>
                    <li>
                      <ReconciliationFilled />
                    </li>
                    <li>
                      <RedEnvelopeFilled />
                    </li>
                    <li>
                      <RedditCircleFilled />
                    </li>
                    <li>
                      <RedditSquareFilled />
                    </li>
                    <li>
                      <RestFilled />
                    </li>
                    <li>
                      <RobotFilled />
                    </li>
                    <li>
                      <RocketFilled />
                    </li>
                    <li>
                      <SafetyCertificateFilled />
                    </li>
                    <li>
                      <SaveFilled />
                    </li>
                    <li>
                      <ScheduleFilled />
                    </li>
                    <li>
                      <SecurityScanFilled />
                    </li>
                    <li>
                      <SettingFilled />
                    </li>
                    <li>
                      <ShopFilled />
                    </li>
                    <li>
                      <ShoppingFilled />
                    </li>
                    <li>
                      <SignalFilled />
                    </li>
                    <li>
                      <SketchCircleFilled />
                    </li>
                    <li>
                      <SketchSquareFilled />
                    </li>
                    <li>
                      <SkinFilled />
                    </li>
                    <li>
                      <SlackCircleFilled />
                    </li>
                    <li>
                      <SmileFilled />
                    </li>
                    <li>
                      <SoundFilled />
                    </li>
                    <li>
                      <StarFilled />
                    </li>
                    <li>
                      <SwitcherFilled />
                    </li>
                    <li>
                      <TabletFilled />
                    </li>
                    <li>
                      <TagFilled />
                    </li>
                    <li>
                      <TagsFilled />
                    </li>
                    <li>
                      <TaobaoSquareFilled />
                    </li>
                    <li>
                      <ThunderboltFilled />
                    </li>
                    <li>
                      <ToolFilled />
                    </li>
                    <li>
                      <TrademarkCircleFilled />
                    </li>
                    <li>
                      <TrophyFilled />
                    </li>
                    <li>
                      <TwitterCircleFilled />
                    </li>
                    <li>
                      <TwitterSquareFilled />
                    </li>
                    <li>
                      <UnlockFilled />
                    </li>
                    <li>
                      <UsbFilled />
                    </li>
                    <li>
                      <VideoCameraFilled />
                    </li>
                    <li>
                      <WalletFilled />
                    </li>
                    <li>
                      <ZhihuCircleFilled />
                    </li>
                    <li>
                      <ZhihuSquareFilled />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* /Chart */}
        </div>
      </div>
    </div>
  );
};
export default MaterialIcons;
